import {
	FormItem,
	ReorderableList,
	Select,
	SelectOption,
	TextInput,
	ValidationError
} from "client/Components";
import { IInputAttachable, IValueInputAttachable } from "client/Forms/attachable";
import { useCallback } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { NedapOnsResourceKind } from "client/Api/Workspace/LiveInformation/NedapOns/nedapOnsLiveInformation";
import { UpdateNedapOnsTabModel } from "client/Api/Workspace/workspace";


const tabKindOptions: readonly SelectOption<NedapOnsResourceKind>[] = [
	{ text: localize("_MyPlanning"), value: NedapOnsResourceKind.MyPlanning },
	{ text: localize("_Clients"), value: NedapOnsResourceKind.Clients },
	{ text: localize("_MySchedule"), value: NedapOnsResourceKind.MySchedule }
];

type EditNedapOnsTabItemProps = {
	attachable: IValueInputAttachable<UpdateNedapOnsTabModel>;
	onRemoveTab: () => void;
};

export const EditNedapOnsTabItem = (props: EditNedapOnsTabItemProps) => {
	const { attachable, onRemoveTab } = props;
	const nameAttachable: IInputAttachable<string> = attachable.for("name");

	const resourceKindChangeHandler = useCallback(
		(newValue: NedapOnsResourceKind | undefined): void => {
			if (
				newValue !== attachable.value
					.resourceKind
			) {
				const onChange: (newValue: string) => void = nameAttachable.attachToTextInput()
					.onChange;

				const nameValue: string = tabKindOptions.find(
					(option) => option.value === newValue
				)
					?.text ?? "";

				onChange(nameValue);
			}
		},
		[
			nameAttachable,
			attachable.value
				.resourceKind
		]
	);

	return (
		<ReorderableList.PanelItem
			{...attachable.attachToReorderableListPanelItem(true)}
			header={
				<Select
					{...attachable
						.for("resourceKind")
						.attachToSelect()
						.withOnChange(resourceKindChangeHandler)}
					options={tabKindOptions}
					placeholder={localize("_PleaseSelect")}
					menuTitle={localize("_Source")}
				/>
			}
			onRemove={onRemoveTab}
		>
			<ValidationError
				{...attachable.for("resourceKind")
					.attachToValidationError()}
			/>
			<FormItem
				label={localize("_Content")}
			>
				<TextInput
					{...nameAttachable.attachToTextInput()}
				/>
				<ValidationError
					{...nameAttachable.attachToValidationError()}
				/>
			</FormItem>
		</ReorderableList.PanelItem>
	);
};

EditNedapOnsTabItem.displayName = "EditNedapOnsTabItem";